import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { LoginService } from "app/services/login.service";
import { environment } from 'environments/environment';


@Component({
  selector: 'app-otras-gestiones',
  templateUrl: './otras-gestiones.component.html',
  styleUrls: ['./otras-gestiones.component.scss']
})
export class OtrasGestionesComponent implements OnInit {

  dataBreadcumbPages: Array<any> = [];
  dataBreadcumbTitle: any;

  constructor(private _loginService: LoginService,
    private router: Router) { 
      this.dataBreadcumbPages = [{ page: 'Otras Gestiones Proveedor', route: '/otras-gestiones' }];
      this.dataBreadcumbTitle = [];
    }


  ngOnInit(): void {
    this._loginService.getAll().subscribe(resp => {
      if(!resp['isLogged'])
          this.router.navigate(['/login'])
    });
  }

  linkPanel(){   
    window.location.href = environment.urlWebSitePhp + 'site/inicio';
  }

  goToConsultas() {
    this.router.navigate(['/proveedores/otras-gestiones/consultas-proveedor']);
  }

  goToConsultasFacturacion() {
    this.router.navigate(['/proveedores/otras-gestiones/consulta-facturacion-proveedor']);
  }

}
